<template>
  <div class="page-container" ref="Home" id="homecontainer" v-images-loaded="loaded">
    <div class="bigscroller">
      <Menu/>
      <MobileMenu />
      <section id="flavors">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <router-view name="bannerHome"></router-view>
        <router-view name="mobileFlavors"></router-view>
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <section id="recetario">
        <span
          class="top watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
        <router-view name="recetario"></router-view>
        <span
          class="bottom watcher"
          v-observe-visibility="visibilityChanged"
        ></span>
      </section>
      <div class="mRetailers">
        <section id="retailers">
          <span
            class="top watcher"
            v-observe-visibility="visibilityChanged"
          ></span>
          <router-view name="retailers"></router-view>
          <router-view name="mobileRetailers"></router-view>  
          <span
            class="bottom watcher"
            v-observe-visibility="visibilityChanged"
          ></span>
        </section>
        <Footer />
      </div>
    </div>
    <Modal v-show="showModal" wichModal="alcoholandhealth" @close="showModal = false"></Modal>
  </div>
</template>

<script>
import Menu from "@/components/Menu";
import MobileMenu from "@/components/MobileMenu";
import VueScrollTo from "vue-scrollto";
import { mapActions, mapGetters } from "vuex";
import Footer from "@/components/FooterHome";
import tagFunctions from '@/utils/tagFunctions.js'
import imagesLoaded from 'vue-images-loaded'
import Modal from "@/components/Modal";

const utm = {
  utm_content: "QR_AvisoAlcohol",
  utm_medium: "PopUp",
  utm_source: "Lata-Strongbow",
}

export default {
  name: "Home",
  props: ["id"],
  components: {
    Menu,
    MobileMenu,
    Footer,
    Modal,
  },
    directives: {
    imagesLoaded
},
  computed: {
    ...mapGetters([
      "getActiveSection",
      "getTriggerSpring",
      "getEdgeScrolling",
      "getScrollMotion",
    ]),
  },
  created() {},
  data() {
    return {
      showModal: false,
      wichModal: "terms",
      fixedLel: true,
      placesDirections: {
        retailerUp: (scrolled) => {
          this.setActiveSection("retailers");
          document.getElementById("app").scroll(0, scrolled);
        },
        retailerDown: (scrolled) => {
          this.setActiveSection("retailers");
          document.getElementById("app").scroll(0, scrolled);
        },
      },
    };
  },
  mounted() {
    this.setLoadStatus({status: false})
    tagFunctions.evPageViewPush('Home')
    //this.checkRouteForInitialScroll();
    VueScrollTo.scrollTo(`#app`, 1, {
          container: "body",
          easing: "linear",
          offset: 0,
          force: true,
          cancelable: true,
          // onStart: function(element) {},
          // onDone: function(element) {},
          // onCancel: function() {},
          x: false,
          y: true,
        });
    const {utm_source, utm_medium, utm_content} = this.$route.query;
    if((utm['utm_source'] === utm_source) && utm['utm_content'] === utm_content && utm['utm_medium'] === utm_medium ) {
      //console.log('show pop up')
      setTimeout(() => {
        this.showModal = true
      }, 3000);
    }
  },
  methods: {
     loaded(){
      this.setLoadStatus({status: true})
    },
    ...mapActions({
      goToSection: "goToSection",
      setActiveSection: "setActiveSection",
      resetEdgeScrollingAction: "resetEdgeScrolling",
      setEdgeScrollingAction: "setEdgeScrolling",
      setLoadStatus: "setLoadStatus"
    }),
    popUpModal(modalType) {
      this.showModal = true;
      this.wichModal = modalType;
    },
    visibilityChanged(isVisible, entry) {
      //  console.log("isvisible1",entry.target.offsetParent)
      if (isVisible) {
        const query = localStorage.getItem('query');
        this.$router.push({ name: entry.target.offsetParent.id, query: {...JSON.parse(query)} }).catch(err => {
    // Ignore the vuex err regarding  navigating to the page they are already on.
    if (
      err.name !== 'NavigationDuplicated' &&
      !err.message.includes('Avoided redundant navigation to current location')
    ) {
      // But print any other errors to the console
      throw err;
    }
  });
        this.setActiveSection({
          willScroll: false,
          section: entry.target.offsetParent.id,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/containers/Home.scss";
@import "~@/styles/variables.scss";
</style>
